import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class PressingAppointmentService {
  url = ConfigService.toApiUrl("v1/pressing-appointments/");

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<any[]>(`${this.url}`);
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  changeStatus(id: any, status: any) {
    return this.http.get<any>(`${this.url}${id}/status/${status}`);
  }
}
